import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Input } from 'antd';
import { SearchOutlined, LoadingOutlined, CloseOutlined } from '@ant-design/icons';
import SearchList from '../Search/SearchList';
import './style.css';
import { isEmpty } from '../../utils/helper';
import { NO_OP } from '../../constants/Constants';
let globalSearchRef = /*#__PURE__*/React.createRef();
const GlobalSearch = props => {
  const {
    globalSearchLoader,
    placeholder,
    list,
    showDropDown,
    globalSearchClickHandler,
    noResultsFoundOption,
    globalSearchLabelFormatter,
    isSearchExpandedInMobile,
    onMobileSearchIconClick,
    onCloseSearchIcon,
    displayInfo,
    searchLabel,
    globalSearchMandatoryContent,
    globalContainerClassName,
    customBackText,
    customMoreText,
    focusGlobalSearch
  } = props;
  const [searchText, setSearchText] = useState('');
  const [activeIndex, setActiveIndex] = useState(-1);
  const inputRef = useRef();
  useEffect(() => {
    document.addEventListener('click', clickHandler, true);
    return () => {
      document.removeEventListener('click', clickHandler, true);
    };
  }, []);
  useEffect(() => {
    if (focusGlobalSearch && inputRef.current) inputRef.current.focus();
  }, [focusGlobalSearch]);
  const clickHandler = e => {
    const withInBoundry = globalSearchRef && globalSearchRef.contains(e.target);
    if (!withInBoundry) {
      globalSearchClickHandler();
    }
  };
  const onChangeHandler = e => {
    const {
      target: {
        value
      }
    } = e;
    setSearchText(value);
    const {
      onGlobalSearch
    } = props;
    onGlobalSearch(value);
  };
  const handleSelect = data => {
    const {
      onSelect
    } = props;
    onSelect(data);
  };
  const onFocusHandler = () => {
    const {
      onGlobalSearchFocusHandler
    } = props;
    onGlobalSearchFocusHandler();
  };
  const onPressEnterHandler = () => {
    const {
      onGlobalSearchPressEnterHandler
    } = props;
    onGlobalSearchPressEnterHandler();
  };
  const handleShowMore = index => {
    setActiveIndex(index);
  };
  const handleBackClick = () => {
    setActiveIndex(-1);
  };
  const handleFormmatter = data => {
    if (globalSearchLabelFormatter) {
      return globalSearchLabelFormatter(data);
    }
    return data.label;
  };
  const onCloseSearchIconClick = () => {
    setSearchText('');
    const {
      onGlobalSearch,
      onGlobalSearchFocusChange
    } = props;
    onGlobalSearch('');
    onCloseSearchIcon();
    onGlobalSearchFocusChange(false);
  };
  const onSuffixHandler = () => {
    if (!globalSearchLoader && searchText) {
      return /*#__PURE__*/React.createElement(CloseOutlined, {
        className: "close-icon",
        onClick: onCloseSearchIconClick
      });
    }
    if (globalSearchLoader && searchText) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingOutlined, {
        className: "search-icon"
      }), /*#__PURE__*/React.createElement(CloseOutlined, {
        className: "close-icon",
        onClick: onCloseSearchIconClick
      }));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "global-search",
    ref: ele => {
      globalSearchRef = ele;
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-with-label ".concat(!isSearchExpandedInMobile ? 'hidden-mobile' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "globalSearchLabel"
  }, searchLabel), /*#__PURE__*/React.createElement("div", {
    className: cx('global-search-container', globalContainerClassName)
  }, /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    className: "search-input",
    value: searchText,
    onChange: onChangeHandler,
    prefix: /*#__PURE__*/React.createElement(SearchOutlined, {
      className: "search-icon"
    }),
    suffix: onSuffixHandler(),
    placeholder: placeholder,
    onFocus: onFocusHandler,
    onPressEnter: onPressEnterHandler
  })), showDropDown && !isEmpty(searchText) && /*#__PURE__*/React.createElement(SearchList, {
    activeIndex: activeIndex,
    customBackText: customBackText,
    customMoreText: customMoreText,
    list: !isEmpty(searchText) && !globalSearchLoader && isEmpty(list) ? noResultsFoundOption : list,
    isListEmpty: !isEmpty(searchText) && !globalSearchLoader && isEmpty(list),
    onShowMoreClick: handleShowMore,
    onBackClick: handleBackClick,
    onSelect: handleSelect,
    formatter: menu => handleFormmatter(menu),
    displayInfo: displayInfo,
    globalSearchMandatoryContent: globalSearchMandatoryContent
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop search-icon-mobile"
  }, !isSearchExpandedInMobile ? /*#__PURE__*/React.createElement(SearchOutlined, {
    color: "white",
    onClick: onMobileSearchIconClick,
    size: 22
  }) : /*#__PURE__*/React.createElement(CloseOutlined, {
    color: "white",
    onClick: onCloseSearchIconClick,
    size: 22
  })));
};
GlobalSearch.propTypes = {
  customBackText: PropTypes.string,
  customMoreText: PropTypes.string,
  displayInfo: PropTypes.any,
  focusGlobalSearch: PropTypes.bool,
  noResultsFoundOption: PropTypes.array,
  onGlobalSearchPressEnterHandler: PropTypes.func,
  globalSearchLabelFormatter: PropTypes.func,
  onMobileSearchIconClick: PropTypes.func,
  onCloseSearchIcon: PropTypes.func,
  onSelect: PropTypes.func,
  globalSearchMandatoryContent: PropTypes.func,
  onGlobalSearchFocusHandler: PropTypes.func,
  onGlobalSearchFocusChange: PropTypes.func,
  onGlobalSearch: PropTypes.func,
  globalSearchLoader: PropTypes.bool,
  placeholder: PropTypes.string,
  list: PropTypes.array,
  showDropDown: PropTypes.bool,
  globalSearchClickHandler: PropTypes.func,
  globalContainerClassName: PropTypes.object,
  searchLabel: PropTypes.string.isRequired
};
GlobalSearch.defaultProps = {
  customBackText: '',
  customMoreText: '',
  displayInfo: '',
  focusGlobalSearch: false,
  noResultsFoundOption: [],
  onGlobalSearchPressEnterHandler: NO_OP,
  globalSearchLabelFormatter: NO_OP,
  onMobileSearchIconClick: NO_OP,
  onCloseSearchIcon: NO_OP,
  onSelect: NO_OP,
  globalSearchMandatoryContent: NO_OP,
  onGlobalSearchFocusHandler: NO_OP,
  onGlobalSearchFocusChange: NO_OP,
  onGlobalSearch: NO_OP,
  globalSearchLoader: false,
  placeholder: '',
  list: [],
  showDropDown: PropTypes.bool,
  globalContainerClassName: {},
  globalSearchClickHandler: NO_OP
};
export default GlobalSearch;